import { pxToRem } from "@/util";
import { Box, Button, Divider, Pagination } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
type props = {
  isDivider: boolean;
  onChange: (
    event: React.ChangeEvent<unknown>,
    value: React.SetStateAction<number>
  ) => void;
  page: number;
  count: number;
};
export default function FootPagination({
  isDivider = true,
  onChange,
  page = 1,
  count = 1,
}: Partial<props>) {
  const { classes } = styles();
  if(count===0)return null;
  return (
    <Box className={classes.container}>
      {isDivider && <Divider />}
      <Box className={classes.sub}>
        <Button
          onClick={(event) => onChange?.(event, Math.max(page - 1, 1))}
          disabled={page === 1}
          variant="outlined"
        >
          Previous
        </Button>

        <Pagination
          count={count}
          shape="rounded"
          page={page}
          onChange={onChange}
          hideNextButton
          hidePrevButton
        />

        <Button
          onClick={(event) => onChange?.(event, Math.max(page + 1, 1))}
          disabled={page === count}
          variant="outlined"
        >
          Next
        </Button>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    marginTop: pxToRem(30),
    gap: theme.spacing(3),
   
  },
  sub: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));
